import { CLUSTER_BOUNDS_PADDING, EventLocationData, MAP_FLY_TO_DURATION, Undefinable, useHistorySearch, ZOOM } from '@eagle/react-common';
import L from 'leaflet';
import { FC, useEffect, useMemo } from 'react';
import { useMap } from 'react-leaflet';
import { TripHistoryMapViewportControllerProps } from '../trip-history-base-view.types';
import { getEventLatLng } from '../trip-history-event-filtering-utils';
import { isTripHistoryMapItem } from '../trip-history-map-item-utils';

export const TripHistoryMapViewportController: FC<TripHistoryMapViewportControllerProps> = ({ selectedEventId, selectedTrip }) => {
  const map = useMap();
  const { eventData } = useHistorySearch();
  const tripEventData = selectedTrip
    ? eventData.find((item) => isTripHistoryMapItem(item, selectedTrip))
    : undefined;
  const tripEvents = useMemo(() => tripEventData?.data.items ?? [], [tripEventData?.data.items]);
  const tripPoints = useMemo(() => {
    return tripEvents
      .map((event) => getEventLatLng(event as EventLocationData))
      .filter((point): point is L.LatLng => Boolean(point));
  }, [tripEvents]);
  const selectedEvent = useMemo(() => {
    if (!selectedEventId) return;
    return tripEvents.find((event) => event.eventId === selectedEventId) as Undefinable<EventLocationData>;
  }, [selectedEventId, tripEvents]);

  useEffect(() => {
    if (!selectedTrip || selectedEventId || !tripPoints.length) return;
    map.flyToBounds(L.latLngBounds(tripPoints).pad(CLUSTER_BOUNDS_PADDING), { duration: MAP_FLY_TO_DURATION });
  }, [map, selectedEventId, selectedTrip, tripPoints]);

  useEffect(() => {
    const selectedEventPoint = getEventLatLng(selectedEvent);
    if (!selectedEventId || !selectedEventPoint) return;
    map.flyTo(selectedEventPoint, Math.max(map.getZoom(), ZOOM.street), { duration: MAP_FLY_TO_DURATION });
  }, [map, selectedEvent, selectedEventId]);

  return <></>;
};
